import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';

import headerStyles from './header.module.scss';

const Header = () => {
  return (
    <header className={`header header-top-transparent ${headerStyles.header}`}>
      <h1 className="brand">Beth's Dad</h1>
      <div className="gold line" />
      <p className="tagline">Generations of Coding Excellence</p>
    </header>
  );
};

Header.propTypes = {

};
Header.defaultProps = {

};

export default Header;
